import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { from, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import Institution from '../interfaces/Institution';

@Injectable({
  providedIn: 'root',
})
export class InstitutionService {
  constructor(private afs: AngularFirestore) { }

  getInstitutions() {
    const institutionsRef: AngularFirestoreCollection<any> = this.afs.collection('institutions');
    return from(institutionsRef.valueChanges());
  }
  getAllInstitutions (limit = 10000) {
    const institutionsRef: AngularFirestoreCollection<any> = this.afs.collection('institutions', (ref) =>
      ref.orderBy('timestamp', 'desc').limit(limit)
    );
    return institutionsRef.get().pipe(
      map((r) => {
        return r.docs.map((doc) => {
          return doc.data();
        });
      })
    );
  }
  getCurrentInstitution(id) {
    const institutionRef: AngularFirestoreCollection<any> = this.afs.collection('institutions', ref => ref.where('id', '==', id))
    return from(institutionRef.valueChanges());
  }

  getCurrentUserOwnedInstitutions(uid) {
    const userInstitutionsRef: AngularFirestoreCollection<any> = this.afs.collection('institutions', ref => ref.where('owner', '==', uid))
    return from(userInstitutionsRef.valueChanges());
  }
  getCurrentUserInstitutions(userInstitutions) {
    let institutions$ = new BehaviorSubject([]);
    let institutions = []
    userInstitutions.forEach(ui => {
      const userInstitutionsRef: AngularFirestoreCollection<any> = this.afs.collection('institutions', ref => ref.where('id', '==', ui))
      institutions.push(from(userInstitutionsRef.valueChanges()))
    })
    institutions$.next(institutions);
    return institutions$;
  }
  getInstitutionMembers(id) {
    const membersRef: AngularFirestoreCollection<any> = this.afs.collection('users', ref => ref.where('institutions', 'array-contains', id))
    return from(membersRef.valueChanges());
  }

  createInstitution(institutionData) {
    return new Promise((resolve, reject) => {
      this.afs.collection('institutions').add(institutionData).then((dRef) => {
        dRef.update({ id: dRef.id }).then(() => {
          resolve(dRef.id);
        });
      });
    })
  }

  updateInstitution(institutionId, d) {
    const institutionRef: AngularFirestoreDocument<any> = this.afs.doc(`institutions/${institutionId}`);
    return institutionRef.update(d);
  }

  deleteInstitution(institutionId) {
    const institutionRef: AngularFirestoreDocument<any> = this.afs.doc(`institutions/${institutionId}`);
    return institutionRef.delete();
  }
}
